<img class="image-preview" [class.logo]="isLogoImage" [src]="imageUrl" alt="image" />
